<template>
  <div class="ts-p-3 ts-rounded">
    <div class="ts-grid ts-grid-cols-1 xl:ts-grid-cols-4 ts-gap-3">
      <div class="ts-flex ts-space-x-3">
        <p>{{ $t('productProfile.purchaseInvoice#') }}:</p>
        <p class="ts-text-blue-600">
          <strong>{{ value.stock_in_number }}</strong>
        </p>
      </div>
      <div class="ts-flex ts-space-x-3">
        <p>{{ $t('productProfile.purchaseInvoiceDate') }}</p>
        <p class="ts-text-yellow-600">
          <strong>{{ value.stock_in_date }}</strong>
        </p>
      </div>
      <div class="ts-flex ts-space-x-3">
        <p>{{ $t('productProfile.invoice#') }}:</p>
        <p>
          <strong>{{ value.invoice_no }}</strong>
        </p>
      </div>
      <div class="ts-flex ts-space-x-3">
        <p>{{ $t('productProfile.createdBy') }} :</p>
        <p>
          <strong>{{ value.created_by }}</strong>
        </p>
      </div>
      <div class="ts-flex ts-space-x-3">
        <p>{{ $t('productProfile.vendor') }}:</p>
        <p> {{ value.vendor_name }}</p>
      </div>
      <div class="ts-flex ts-space-x-3">
        <p>{{ $t('productProfile.confirmedDate') }}:</p>
        <p> {{ value.confirmed_date }}</p>
      </div>
      <div class="ts-flex ts-space-x-3">
        <p>{{ $t('productProfile.confirmedBy') }}:</p>
        <p> {{ value.confirmed_by }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
}
</script>